import * as React from 'react';
import styled, { CSSProperties } from 'styled-components';
import { Stack } from '~uikit';

type Props = {
  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
};

const ModalContent = ({ children, className, ...rest }: Props) => {
  return (
    <Content
      axis="y"
      spacing="xlarge"
      align="center"
      justify="space-between"
      className={className}
      {...rest}
    >
      {children}
    </Content>
  );
};

const Content = styled(Stack)`
  display: flex;
  padding: ${({ theme }) => theme.spacing.medium}px;
  background-color: ${({ theme }) => theme.colors.muted6};
  overflow-y: auto;
  overflow-x: hidden;
  flex: 1;
`;

export default ModalContent;
